<template>
  <div class="are-you-sure">
    <p>{{ props.message }}</p>
    <Button :label="props.yesButtonLabel" :version="props.yesButtonVersion" class="are-you-sure-yes-button" @click="handleDelete" />
    <Button :label="props.noButtonLabel" :version="props.noButtonVersion" class="are-you-sure-no-button" @click="handleCancel" />
  </div>
</template>

<script setup lang="ts">
import { PropType, ref } from 'vue';
import Button from './Button.vue';
const props = defineProps({
  message: {
    type: String,
    default: 'This will permanently delete the match and cannot be undone.',
  },
  yesButtonLabel: {
    type: String,
    default: 'Yes, Delete Match',
  },
  noButtonLabel: {
    type: String,
    default: 'No, Cancel',
  },
  yesButtonVersion: {
    type: String as PropType<'error' | 'primary' | 'action' | 'secondary' | 'highlight' | 'grey' | 'white'>,
    default: 'error',
  },
  noButtonVersion: {
    type: String as PropType<'error' | 'primary' | 'action' | 'secondary' | 'highlight' | 'grey' | 'white'>,
    default: 'primary',
  },
  action: {
    type: String,
    default: 'delete',
  },
});
const emit = defineEmits(['action']);
const handleDelete = () => {
  emit('action', props.action);
};

const handleCancel = () => {
  emit('action', 'cancel');
};
</script>

<style scoped lang="scss">
.are-you-sure {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  p {
    font-size: 16px;
    font-weight: 500;
  }
  .button {
    width: 100%;
  }
}
</style>
